export default {
  banner: {
    title: "连接全球人与应用",
    subtitle:
      "Authing 是一款提供用户身份管理和员工身份管理 ( CIAM & EIAM ） 解决方案的云服务，凭借安全、完善、易用著称的用户认证和管理平台。",
    "try-time-tip": "3000 次免费认证次数",
    "try-function-tip": "体验所有功能",
  },
  twoThing: {
    title: "我们为你做两件事",
    subtitle:
      "中国石油、招商银行等多家世界 500 强都已部署 Authing 作为员工和用户的身份方案",
    "item-one": {
      title: "用户身份管理",
      subtitle: "五行代码为你的客户打造安全无缝的认证体验",
      "list-one": "集成第三方登录",
      "list-two": "手机号码闪验",
      "list-three": "多因素认证 MFA",
      "list-four": "单点登录 SSO",
      "list-five": "通用登录组件",
      "list-six": "自定义认证流程",
    },
    "item-two": {
      title: "员工身份管理",
      subtitle: "无需开发，集成企业内部系统，统一管控员工的身份权限",
      "list-one": "单点登录 SSO",
      "list-two": "多因素认证 MFA",
      "list-three": "支持私有化部署",
      "list-four": "权限管理",
      "list-five": "成员号码闪验",
    },
  },
  advantage: {
    title: "Authing 的优势",
    subtitle: "Authing 让身份管理变得简单",
    "number-unit": "万",
    "item-one": {
      title: "降低开发成本",
      descript:
        "调查显示，Authing 将与认证相关的开发工时减少了 51%，将运维时间减少 200 小时，加速产品研发，加快业务上线。",
    },
    "item-two": {
      title: "登录安全性",
      descript:
        "专业的事情交给专家解决，通过将繁琐而重要的身份任务交给 Authing，可以轻松对冲安全风险。",
    },
    "item-three": {
      title: "每月安全登录次数",
      descript:
        "每月数千万次安全的身份验证背后，是 Authing 在帮助你集中管理来自所有来源的用户，为你创造交叉销售的机会。",
    },
  },
  IAM: {
    title: "构建适合你的现代用户中心",
    subtitle:
      "Authing 身份云可以帮助企业安全高效地管理外部用户账号和内部员工权限，保障企业专注核心业务。",
    "item-one": {
      title: "单点登录",
      subtitle: "一次登录，即可访问所有已授权限的应用程序。",
    },
    "item-two": {
      title: "登录组件",
      subtitle:
        "只需几行代码，立即生成注册登录表单。你也可以使用 Authing SDK 来自定义表单的形式。",
    },
    "item-tree": {
      title: "多因素认证",
      subtitle: " Authing 多因素认证支持等多种登录验证方式。",
    },
    "item-four": {
      title: "用户管理",
      subtitle:
        "Authing DashBoard 集成了用户信息、权限、数据分析管理等功能，方便你一站式完成用户认证。",
    },
  },
  industry: {
    title: "行业解决方案",
    subtitle: "我们为不同行业和应用领域提供专业的解决方案，为企业提升生产力。",
    "item-one": {
      title: "政府",
      descript: "让公民用一个账号访问所有系统，安全登录政务服务。",
    },
    "item-two": {
      title: "出版",
      descript:
        "让读者专注阅读，数亿用户在弹指间伸缩，发行、作者、编辑，尽在掌控。",
    },
    "item-tree": {
      title: "金融",
      descript: "赋能金融云，直观可视化的分析平台，符合国家监管标准。",
    },
    "item-four": {
      title: "游戏",
      descript:
        "让玩家快进来，让黑客远离点，多身份源快速登录，保证用户访问敏感信息。",
    },
  },
  code: {
    title: "五行代码将登录嵌入任何应用",
    subtitle: "只需喝一杯咖啡的时间，你就能拥有安全强大的身份模块。",
    other: "支持任何技术栈",
  },
  news: {
    title: "最新资讯",
  },
  other: {
    title: "面向企业提供更好的产品和服务",
    "item-one": {
      common:
        "“在云身份认证、单点登录、无服务器计算等新兴技术领域，Authing 很创新。”",
      author: "东南大学",
    },
    "item-two": {
      common:
        "“Authing 提供完善的单点登录平台，帮助我们快速实现高效用户管理。”",
      author: "中国石油",
    },
    "item-three": {
      common:
        "“对比过众多厂商后更能感受到 Authing 的优势，这是一款经过思考做出来的产品。”",
      author: "高等教育出版社",
    },
    "item-four": {
      common:
        "“Authing 打通飞书产品，为我们提供身份源能力，快速的部署及开发者友好，为我们节省了大量的研发人力、费用和周期，让我们将这些宝贵的资源更多应用在公司和客户上。”",
      author: "元气森林",
    },
    "item-five": {
      common:
        "“Authing 为我们提高效率，减少开发运维费用，并节省了宝贵的时间和资源。”",
      author: "大众汽车",
    },
    "item-six": {
      common: "“Authing 的客户成功团队总能最快响应。”",
      author: "丰田",
    },
    "item-seven": {
      common:
        "“每当我们需要 Authing 时，Authing 的客户成功团队都会随时响应。有时我查看时间，发现北京时间已是午夜，但是 Authing 团队仍在工作。我真的很感激。向 Authing 致敬。”",
      author: "德高",
    },
    "item-eight": {
      common:
        "“我们目前内外部用户众多，涉及几十个应用系统的手工创建、删除、账户生命周期管理等，工作量巨大，容易错漏造成安全隐患。而 Authing 帮助我们解决了身份安全的挑战。”",
      author: "",
    },
    "customer-detail": "阅读客户成功案例",
    "customer-detail-default": "详细案例正在赶来的路上",
    "title-cooperatner": "合作伙伴",
    brand: {
      "item-one": "ISO 9001 质量体系认证",
      "item-one1": "ISO/IEC 20000-1 服务管理体系",
      "item-one2": "ISO 27001 信息安全管理体系",
      "item-two": "通用数据保护条例",
      "item-tree": "中国网络安全产业白皮书",
      "item-four": "网络安全三级等保",
      "item-five": "国家高新技术企业",
    },
    slogn: "仅需一步即可完成注册，享受 3000 次免费认证次数。",
  },
  applicationGateway: {
    title: "应用集成网关",
    subtitle: "将现代身份扩展到本地应用程序，保护你的混合云",
  },
};
